export class ChaseProfileTransactionDetails {
    // OrderIds: string;
    // TransId: string;
    // InvoiceIds: string;
    // TransAmount: string;
    // AccountExecutive: string;
    // Station: string;
    // PaymentMode: string;
    
    //Rename All Fields to camelCase
    orderIds: string;
    transId: string;
    invoiceIds: string;
    transAmount: string;
    accountExecutive: string;
    station: string;
    paymentMode: string;
}
